// extracted by mini-css-extract-plugin
module.exports = {"affixMenuWrap":"affixMenu_affixMenuWrap__QTrHo","menuItem":"affixMenu_menuItem__3J7WP"};